import { render, staticRenderFns } from "./ChipsCombobox.vue?vue&type=template&id=603d190a"
import script from "./ChipsCombobox.vue?vue&type=script&lang=js"
export * from "./ChipsCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports